'use client';

import { Box, Stack, Typography } from '@mui/material';
import { PdpInfoDTO } from '@/types/models';
import { planPhaseMapper } from '@/utils/mapper/planPhase';
interface PlanInfoSummaryProps {
  data: PdpInfoDTO;
}
const PlanInfoSummary = ({
  data
}: PlanInfoSummaryProps) => {
  const items = [{
    key: 'numberOfInvestors',
    value: data.investors,
    title: 'تعداد سرمایه‌گذار',
    preValue: 'کاربر',
    infoContent: null
  }, {
    key: 'plan_phases',
    value: data.status === 'funded' ? data?.plan_phase_title : planPhaseMapper[data.status],
    title: 'وضعیت طرح',
    preValue: '',
    infoContent: null
  }];
  return <Box sx={{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    p: 'var(--spacing_m)'
  }} data-sentry-element="Box" data-sentry-component="PlanInfoSummary" data-sentry-source-file="PlanInfoSummary.tsx">
      {items.map((item, idx) => {
      return <Box key={'investment_summary_' + item.key} sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'center',
        borderLeft: idx === 1 ? '1px solid' : '0px',
        borderColor: 'stroke.stroke2',
        px: 'var(--spacing_xs)',
        gap: 'var(--spacing_xs)',
        width: '50%'
        // minHeight: 64,
      }}>
            <Stack direction='row' alignItems='center' gap='var(--spacing_xxxs)'>
              <Typography variant='captionRegular__Wallfund' color='text.text2'>
                {item.title}
              </Typography>
            </Stack>
            <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 'var(--spacing_xxs)',
          textAlign: 'center'
        }}>
              <Typography variant='bodyLargeStrong__Wallfund' color='text.text'>
                {item.value}
              </Typography>
              <Typography variant='captionSmallMedium__Wallfund' color='text.text2'>
                {item.preValue}
              </Typography>
            </Box>
          </Box>;
    })}
    </Box>;
};
export default PlanInfoSummary;